/* @ngInject */
const owner = (
  ownerAsk,
  ownerData,
  ownerFormat,
  ownerGo,
  ownerLocal,
  ownerMetadata,
  ownerRequest
) => {
  const self = {}

  self.new = () => {
    return {
      id: null,
      society: null,
      address: null,
      cp: null,
      city: null,
      country: null,
      contacts: [],
    }
  }

  self.ask = ownerAsk
  self.data = ownerData
  self.format = ownerFormat
  self.go = ownerGo
  self.local = ownerLocal
  self.metadata = ownerMetadata
  self.request = ownerRequest

  return self
}

export default owner



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/owner.service.js